var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogogmb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4503 4.3654C10.6077 3.57763 9.48309 3.14846 8.31954 3.1661C6.19037 3.1661 4.38207 4.57411 3.73732 6.47006L3.73719 6.46997V6.47016C3.39536 7.46361 3.39533 8.53934 3.7371 9.53281H3.74031C4.38806 11.4258 6.19336 12.8338 8.32254 12.8338C9.42139 12.8338 10.3648 12.5584 11.096 12.0719V12.0696C11.9567 11.5111 12.5445 10.6322 12.7274 9.63868H8.31909V6.55812H16.0171C16.1131 7.09311 16.1581 7.63985 16.1581 8.18365C16.1581 10.6167 15.271 12.6737 13.7276 14.067L13.7294 14.0684C12.377 15.2912 10.5207 15.9996 8.31954 15.9996C5.23379 15.9996 2.41192 14.2948 1.02644 11.5935L1.02624 11.5937C-0.131307 9.3332 -0.131307 6.67005 1.02624 4.4096H1.0265L1.02637 4.4095C2.41183 1.70519 5.23374 0.000294954 8.31954 0.000294954C10.3468 -0.0232208 12.305 0.723404 13.7804 2.08144L11.4503 4.3654Z",
    fill: "#BED000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogogmb);
export default __webpack_public_path__ + "static/media/logogmb.15ce5f1d72195c4a7a62b9ae0262419b.svg";
export { ForwardRef as ReactComponent };